var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_AddOverseaWarehouse"),
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "app-main-content railwayStation" }, [
        _c("div", { staticClass: "grid-view" }, [
          _c("div", { staticClass: "main-content" }, [
            _c(
              "div",
              { staticClass: "operations" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "50px",
                      "label-position": "left"
                    },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                        _vm.filter.pageNum = 1
                        _vm.toQuery()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.btn.query") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "310px" },
                              attrs: {
                                no: "searchInput",
                                placeholder: _vm.$t("common.tips.fuzzySearch")
                              },
                              model: {
                                value: _vm.filter.likeName,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "likeName", $$v)
                                },
                                expression: "filter.likeName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              no: "query"
                            },
                            on: {
                              click: function($event) {
                                _vm.filter.pageNum = 1
                                _vm.toQuery()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.query")) + " ")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", "min-height": "320px" },
                  attrs: {
                    "grid-params": _vm.girdParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "show-side-bar": false
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.girdParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.girdParams = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "add" },
              on: { click: _vm.addHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.add")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.visible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }